var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 162,
    viewBox: "0 0 130 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 107.09V56.0266L126.786 67.8991L124.84 104.191L116.462 107.09Z",
    fill: "url(#paint0_linear_32504_60022)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4211 107.09V56.0266L3.09717 67.8991L5.04278 104.191L13.4211 107.09Z",
    fill: "url(#paint1_linear_32504_60022)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4204 9.37073L15.4454 11.3561V82.0746L13.4204 83.4643V9.37073Z",
    fill: "url(#paint2_linear_32504_60022)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3562 7.82227V62.3402L3.09717 67.8992L5.04278 104.192L11.3562 106.375V133.138L13.4211 131.709V107.09V84.0204V60.9505V9.37084L11.3562 7.82227Z",
    fill: "url(#paint3_linear_32504_60022)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.363 75.7212L119.082 72.624V96.0513L123.449 93.51L124.363 75.7212Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.461 9.37073L114.396 11.3561V82.0746L116.461 83.4643V9.37073Z",
    fill: "url(#paint4_linear_32504_60022)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.87 41.2554V15.2869L95.2178 13.1427V15.0089L108.043 16.8752V39.4686L109.87 41.2554Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.797 113.006V113.284C108.797 113.84 109.234 114.277 109.79 114.277H112.172C112.728 114.277 113.165 113.84 113.165 113.284V113.006H108.797Z",
    fill: "url(#paint5_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.252 112.213H109.711C109.433 112.213 109.155 112.451 109.155 112.768C109.155 113.046 109.393 113.324 109.711 113.324H112.252C112.53 113.324 112.808 113.086 112.808 112.768C112.808 112.49 112.57 112.213 112.252 112.213Z",
    fill: "url(#paint6_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.797 118.049V118.327C108.797 118.883 109.234 119.32 109.79 119.32H112.172C112.728 119.32 113.165 118.883 113.165 118.327V118.049H108.797Z",
    fill: "url(#paint7_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.252 117.216H109.711C109.433 117.216 109.155 117.454 109.155 117.772C109.155 118.05 109.393 118.328 109.711 118.328H112.252C112.53 118.328 112.808 118.089 112.808 117.772C112.808 117.494 112.57 117.216 112.252 117.216Z",
    fill: "url(#paint8_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.797 122.973V123.251C108.797 123.807 109.234 124.244 109.79 124.244H112.172C112.728 124.244 113.165 123.807 113.165 123.251V122.973H108.797Z",
    fill: "url(#paint9_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.252 122.179H109.711C109.433 122.179 109.155 122.417 109.155 122.735C109.155 123.013 109.393 123.291 109.711 123.291H112.252C112.53 123.291 112.808 123.053 112.808 122.735C112.808 122.457 112.57 122.179 112.252 122.179Z",
    fill: "url(#paint10_linear_32504_60022)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.172 112.014H109.79C109.234 112.014 108.797 112.45 108.797 113.006C108.797 113.562 109.234 113.999 109.79 113.999H112.172C112.728 113.999 113.165 113.562 113.165 113.006C113.165 112.45 112.728 112.014 112.172 112.014Z",
    fill: "url(#paint11_linear_32504_60022)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.172 117.057H109.79C109.234 117.057 108.797 117.493 108.797 118.049C108.797 118.605 109.234 119.042 109.79 119.042H112.172C112.728 119.042 113.165 118.605 113.165 118.049C113.165 117.493 112.728 117.057 112.172 117.057Z",
    fill: "url(#paint12_linear_32504_60022)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.172 122.02H109.79C109.234 122.02 108.797 122.457 108.797 123.013C108.797 123.568 109.234 124.005 109.79 124.005H112.172C112.728 124.005 113.165 123.568 113.165 123.013C113.165 122.457 112.728 122.02 112.172 122.02Z",
    fill: "url(#paint13_linear_32504_60022)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4203 16.0414C14.4924 16.0414 15.366 20.8459 15.366 26.7623C15.366 32.6787 14.4924 37.4833 13.4203 37.4833C12.3482 37.4833 11.4746 32.6787 11.4746 26.7623C11.4746 20.8459 12.3482 16.0414 13.4203 16.0414Z",
    fill: "url(#paint14_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M110.982 127.937C113.701 127.937 115.905 123.546 115.905 118.129C115.905 112.712 113.701 108.321 110.982 108.321C108.262 108.321 106.058 112.712 106.058 118.129C106.058 123.546 108.262 127.937 110.982 127.937Z",
    fill: "url(#paint15_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.87 15.1282C110.704 15.1282 111.379 20.9651 111.379 28.1918C111.379 35.4186 110.704 41.2555 109.87 41.2555C109.036 41.2555 108.361 35.4186 108.361 28.1918C108.361 20.9651 109.036 15.1282 109.87 15.1282Z",
    fill: "url(#paint16_radial_32504_60022)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.746 67.8992L118.527 62.3402V7.82227L116.462 9.37084V60.9505V84.0204V107.09V131.709L118.527 133.138V106.375L124.84 104.192L126.746 67.8992Z",
    fill: "url(#paint17_linear_32504_60022)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47925 75.7212L10.7603 72.624V96.0513L6.39244 93.51L5.47925 75.7212Z",
    fill: "url(#paint18_linear_32504_60022)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82959 76.4755L9.45028 74.9269V93.7878L7.70315 92.7554L6.82959 76.4755Z",
    fill: "url(#paint19_radial_32504_60022)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39258 93.5099L7.70298 92.7555L9.45011 93.7879L10.7604 96.0512L6.39258 93.5099Z",
    fill: "url(#paint20_linear_32504_60022)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82928 76.4756L5.47925 75.7212L10.7603 72.624L9.44997 74.927L6.82928 76.4756Z",
    fill: "url(#paint21_linear_32504_60022)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47925 75.7213L6.82928 76.4757L7.70284 92.7557L6.39244 93.5101L5.47925 75.7213Z",
    fill: "url(#paint22_linear_32504_60022)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44995 93.788V74.927L10.7602 72.624V96.0513L9.44995 93.788Z",
    fill: "url(#paint23_linear_32504_60022)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.363 75.7212L119.082 72.624V96.0513L123.449 93.51L124.363 75.7212Z",
    fill: "url(#paint24_linear_32504_60022)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.013 76.4755L120.393 74.9269V93.7878L122.179 92.7554L123.013 76.4755Z",
    fill: "url(#paint25_radial_32504_60022)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.449 93.5099L122.179 92.7555L120.392 93.7879L119.082 96.0512L123.449 93.5099Z",
    fill: "url(#paint26_linear_32504_60022)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.013 76.4756L124.363 75.7212L119.082 72.624L120.392 74.927L123.013 76.4756Z",
    fill: "url(#paint27_linear_32504_60022)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.363 75.7213L123.013 76.4757L122.179 92.7557L123.45 93.5101L124.363 75.7213Z",
    fill: "url(#paint28_linear_32504_60022)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.392 93.788V74.927L119.082 72.624V96.0513L120.392 93.788Z",
    fill: "url(#paint29_linear_32504_60022)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13993 64.564C12.6268 64.564 16.28 73.4187 16.28 84.3779C16.28 95.337 12.6268 104.192 8.13993 104.192C3.65301 104.192 0 95.337 0 84.3779C0 73.4187 3.65301 64.564 8.13993 64.564Z",
    fill: "url(#paint30_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.742 64.564C126.229 64.564 129.882 73.4187 129.882 84.3779C129.882 95.337 126.229 104.192 121.742 104.192C117.255 104.192 113.602 95.337 113.602 84.3779C113.602 73.4187 117.255 64.564 121.742 64.564Z",
    fill: "url(#paint31_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M9.2119 124.641C10.1549 124.641 10.9193 106.596 10.9193 84.3377C10.9193 62.0791 10.1549 44.0349 9.2119 44.0349C8.26892 44.0349 7.50439 62.0791 7.50439 84.3377C7.50439 106.596 8.26892 124.641 9.2119 124.641Z",
    fill: "url(#paint32_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M7.30552 64.1664C7.70259 64.1664 8.02022 73.2196 8.02022 84.3376C8.02022 95.4556 7.70259 104.509 7.30552 104.509C6.90845 104.509 6.59082 95.4556 6.59082 84.3376C6.59082 73.2196 6.90845 64.1664 7.30552 64.1664Z",
    fill: "url(#paint33_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M120.63 124.641C121.573 124.641 122.337 106.596 122.337 84.3377C122.337 62.0791 121.573 44.0349 120.63 44.0349C119.687 44.0349 118.923 62.0791 118.923 84.3377C118.923 106.596 119.687 124.641 120.63 124.641Z",
    fill: "url(#paint34_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M122.616 64.1664C122.219 64.1664 121.901 73.2196 121.901 84.3376C121.901 95.4556 122.219 104.509 122.616 104.509C123.013 104.509 123.33 95.4556 123.33 84.3376C123.33 73.2196 123.013 64.1664 122.616 64.1664Z",
    fill: "url(#paint35_radial_32504_60022)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0757 124.005V151.681L64.922 158.908L85.8079 151.681V124.005H44.0757Z",
    fill: "#9B9B9B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3381 124.005V150.053L64.9212 156.526L83.5438 150.053V124.005H46.3381Z",
    fill: "url(#paint36_radial_32504_60022)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8081 124.005V151.681L88.0714 153.27V124.005H85.8081Z",
    fill: "url(#paint37_linear_32504_60022)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8078 151.681V124.005H83.5444V150.053L85.8078 151.681Z",
    fill: "url(#paint38_linear_32504_60022)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3389 150.053V124.005H44.0757V151.681L46.3389 150.053Z",
    fill: "url(#paint39_linear_32504_60022)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0754 151.681V124.005H41.812V153.27L44.0754 151.681Z",
    fill: "url(#paint40_linear_32504_60022)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5946 153.587L64.9216 158.908V161.29L49.5946 155.97L41.812 153.269L44.0754 151.681L49.5946 153.587Z",
    fill: "url(#paint41_linear_32504_60022)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.922 158.908L49.5949 153.588L44.0757 151.682L46.3389 150.054L49.5949 151.205L64.922 156.526V158.908Z",
    fill: "url(#paint42_linear_32504_60022)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9219 158.908L80.2885 153.587L85.8078 151.681L88.0711 153.269L80.2885 155.97L64.9219 161.29V158.908Z",
    fill: "url(#paint43_linear_32504_60022)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8078 151.682L80.2885 153.588L64.9219 158.908V156.526L80.2885 151.205L83.5444 150.054L85.8078 151.682Z",
    fill: "url(#paint44_linear_32504_60022)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4216 83.4647L15.4466 82.075L64.9219 99.1888V101.333L13.4216 83.4647Z",
    fill: "url(#paint45_linear_32504_60022)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 83.4647L114.397 82.075L64.9219 99.1888V101.333L116.462 83.4647Z",
    fill: "url(#paint46_linear_32504_60022)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.922 151.761V101.333L13.4218 83.4643L11.3569 82.7496V133.138L64.922 151.761Z",
    fill: "url(#paint47_linear_32504_60022)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9219 101.333V151.761L118.527 133.138V82.7496L116.462 83.4643L64.9219 101.333Z",
    fill: "url(#paint48_linear_32504_60022)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.922 149.577L13.4218 131.709L11.3569 133.138L64.922 151.761V149.577Z",
    fill: "url(#paint49_linear_32504_60022)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 131.709L64.9219 149.577V151.761L118.527 133.138L116.462 131.709Z",
    fill: "url(#paint50_linear_32504_60022)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4458 11.3565V81.9956L64.9211 99.1888L114.396 81.9956V11.3565L64.9211 4.12976L15.4458 11.3565Z",
    fill: "url(#paint51_radial_32504_60022)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1887 88.5467L103.676 9.80737L114.397 11.356V82.0745L64.9222 99.1883L34.1887 88.5467Z",
    fill: "url(#paint52_radial_32504_60022)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7523 17.6696V30.2568L20.9258 28.4303V16.0814L64.961 9.64879L93.4311 13.818V15.6446L64.961 11.4753L22.7523 17.6299V17.6696ZM22.7523 31.5672V54.4782L20.0125 57.218V78.8187L64.9214 94.4236L109.83 78.8187V42.6058L109.751 42.5263L108.917 41.6925L107.09 39.866V17.7094L94.265 15.8431V13.1033L64.9214 8.81494L20.0125 15.3666V28.8671L22.7523 31.6069V31.5672ZM22.7523 55.7488V76.8334L54.2798 87.7925V89.7382L20.9258 78.1437V57.5754L22.7523 55.7488ZM55.1931 88.1102L64.961 91.4853L74.7291 88.1102V90.0559L64.961 93.431L55.1931 90.0559V88.1102ZM75.6025 87.7925L107.13 76.8334V41.1366L108.957 42.9631V78.1437L75.6025 89.7382V87.7925ZM23.6656 18.4638V76.198L64.961 90.5323L106.256 76.198V18.4638L64.961 12.4283L23.6656 18.4638Z",
    fill: "url(#paint53_radial_32504_60022)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4218 9.3709L64.922 2.06478V0L11.3569 7.82232L13.4218 9.3709Z",
    fill: "url(#paint54_linear_32504_60022)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9219 2.06482L13.4216 9.37094L15.4466 11.3563L64.9219 4.1296V2.06482Z",
    fill: "url(#paint55_linear_32504_60022)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.462 9.3709L64.9219 2.06478V0L118.527 7.82232L116.462 9.3709Z",
    fill: "url(#paint56_linear_32504_60022)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9219 2.06482L116.462 9.37094L114.397 11.3563L64.9219 4.1296V2.06482Z",
    fill: "url(#paint57_linear_32504_60022)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0125 30.0977V55.9073L21.8391 54.0411V31.9242L20.0125 30.0977Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9209 91.4855L55.1926 88.0707V90.0163L64.9209 93.3914L74.6889 90.0163V88.0707L64.9209 91.4855Z",
    fill: "url(#paint58_radial_32504_60022)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.922 111.26L63.9293 102.048L22.2764 86.5619L64.922 101.333V111.26Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4209 50.7062L12.6664 9.64899L11.5942 8.021L13.54 8.77544L29.9389 7.02832L13.4209 9.37105V50.7062Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8157 6.1943L64.4049 1.42944L64.9211 0.158813V2.06476L35.8157 6.1943Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6915 129.326H103.874V125.355H94.9402V109.949H90.6915V129.326ZM74.8484 129.326H88.3091V125.355H79.097V121.186H87.1575V117.215H79.097V113.88H88.3091V109.909H74.8484V129.286V129.326ZM67.0261 129.326L73.1807 110.703V109.075L69.2893 109.393L65.3186 121.305L64.9612 123.33H64.8421L64.4848 121.305L60.5141 109.393L56.6227 109.075V110.703L62.7774 129.326H66.9863H67.0261ZM41.5738 129.326H55.0344V125.355H45.8223V121.186H53.883V117.215H45.8223V113.88H55.0344V109.909H41.5738V129.286V129.326ZM25.9688 129.326H39.1516V125.355H30.2174V109.949H25.9688V129.326Z",
    fill: "#4D5E6E"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6915 127.698H103.874V123.727H94.9402V108.321H90.6915V127.698ZM74.8484 127.698H88.3091V123.727H79.097V119.558H87.1575V115.587H79.097V112.252H88.3091V108.281H74.8484V127.658V127.698ZM67.0261 127.698L73.1807 109.075L69.2893 107.765L65.3186 119.677L64.9612 121.702H64.8421L64.4848 119.677L60.5141 107.765L56.6227 109.075L62.7774 127.698H66.9863H67.0261ZM41.5738 127.698H55.0344V123.727H45.8223V119.558H53.883V115.587H45.8223V112.252H55.0344V108.281H41.5738V127.658V127.698ZM25.9688 127.698H39.1516V123.727H30.2174V108.321H25.9688V127.698Z",
    fill: "url(#paint59_linear_32504_60022)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6772 113.006V113.284C16.6772 113.84 17.114 114.277 17.6699 114.277H20.0524C20.6083 114.277 21.0451 113.84 21.0451 113.284V113.006H16.6772Z",
    fill: "url(#paint60_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1322 112.213H17.5909C17.3129 112.213 17.0349 112.451 17.0349 112.768C17.0349 113.046 17.2732 113.324 17.5909 113.324H20.1322C20.4101 113.324 20.688 113.086 20.688 112.768C20.688 112.49 20.4498 112.213 20.1322 112.213Z",
    fill: "url(#paint61_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6772 118.049V118.327C16.6772 118.883 17.114 119.32 17.6699 119.32H20.0524C20.6083 119.32 21.0451 118.883 21.0451 118.327V118.049H16.6772Z",
    fill: "url(#paint62_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1322 117.216H17.5909C17.3129 117.216 17.0349 117.454 17.0349 117.772C17.0349 118.05 17.2732 118.328 17.5909 118.328H20.1322C20.4101 118.328 20.688 118.089 20.688 117.772C20.688 117.494 20.4498 117.216 20.1322 117.216Z",
    fill: "url(#paint63_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6772 122.973V123.251C16.6772 123.807 17.114 124.244 17.6699 124.244H20.0524C20.6083 124.244 21.0451 123.807 21.0451 123.251V122.973H16.6772Z",
    fill: "url(#paint64_linear_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1322 122.179H17.5909C17.3129 122.179 17.0349 122.417 17.0349 122.735C17.0349 123.013 17.2732 123.291 17.5909 123.291H20.1322C20.4101 123.291 20.688 123.053 20.688 122.735C20.688 122.457 20.4498 122.179 20.1322 122.179Z",
    fill: "url(#paint65_linear_32504_60022)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0914 112.014H17.709C17.1531 112.014 16.7163 112.45 16.7163 113.006C16.7163 113.562 17.1531 113.999 17.709 113.999H20.0914C20.6473 113.999 21.0841 113.562 21.0841 113.006C21.0841 112.45 20.6473 112.014 20.0914 112.014Z",
    fill: "url(#paint66_linear_32504_60022)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0914 117.057H17.709C17.1531 117.057 16.7163 117.493 16.7163 118.049C16.7163 118.605 17.1531 119.042 17.709 119.042H20.0914C20.6473 119.042 21.0841 118.605 21.0841 118.049C21.0841 117.493 20.6473 117.057 20.0914 117.057Z",
    fill: "url(#paint67_linear_32504_60022)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0914 122.02H17.709C17.1531 122.02 16.7163 122.457 16.7163 123.013C16.7163 123.568 17.1531 124.005 17.709 124.005H20.0914C20.6473 124.005 21.0841 123.568 21.0841 123.013C21.0841 122.457 20.6473 122.02 20.0914 122.02Z",
    fill: "url(#paint68_linear_32504_60022)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M20.0122 56.3839C21.3499 56.3839 22.4344 50.3928 22.4344 43.0025C22.4344 35.6122 21.3499 29.6212 20.0122 29.6212C18.6745 29.6212 17.5901 35.6122 17.5901 43.0025C17.5901 50.3928 18.6745 56.3839 20.0122 56.3839Z",
    fill: "url(#paint69_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8613 108.321C21.6011 108.321 23.7849 112.729 23.7849 118.129C23.7849 123.529 21.5614 127.937 18.8613 127.937C16.1612 127.937 13.9375 123.529 13.9375 118.129C13.9375 112.729 16.1612 108.321 18.8613 108.321Z",
    fill: "url(#paint70_radial_32504_60022)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6387 101.333C70.6387 104.47 68.0974 107.011 64.9606 107.011C61.8237 107.011 59.2825 104.47 59.2825 101.333C59.2825 98.1958 61.8237 95.6545 64.9606 95.6545C68.0974 95.6545 70.6387 98.1958 70.6387 101.333Z",
    fill: "url(#paint71_radial_32504_60022)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M41.256 43.2024L42.606 40.9391L42.8046 41.0583L41.9708 43.3216V63.6914H36.1338V72.3475H57.7742V63.6914H51.9372V26.7637H44.1149L32.6792 38.1993L39.4692 44.9893L41.256 43.2024ZM70.5201 26.7637L61.586 34.8639V64.287L70.5201 72.3872H88.309L97.2431 64.287V34.8639L88.309 26.7637H70.5201ZM84.9736 63.6914H75.0071L87.9119 43.0833V60.9913L84.9736 63.6914ZM73.8557 35.4596H83.8221L70.9172 56.0676V38.1596L73.8557 35.4596Z",
    fill: "url(#paint72_linear_32504_60022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32504_60022",
    x1: 116.462,
    y1: 81.5583,
    x2: 126.786,
    y2: 81.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B3840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204954"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32504_60022",
    x1: 3.09717,
    y1: 81.5583,
    x2: 13.4211,
    y2: 81.5583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32504_60022",
    x1: 13.4204,
    y1: 46.4175,
    x2: 15.4454,
    y2: 46.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32504_60022",
    x1: 3.09717,
    y1: 70.4802,
    x2: 13.4211,
    y2: 70.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32504_60022",
    x1: 114.396,
    y1: 46.4175,
    x2: 116.461,
    y2: 46.4175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32504_60022",
    x1: 110.981,
    y1: 114.277,
    x2: 110.981,
    y2: 113.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32504_60022",
    x1: 110.981,
    y1: 113.285,
    x2: 110.981,
    y2: 112.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32504_60022",
    x1: 110.981,
    y1: 119.28,
    x2: 110.981,
    y2: 118.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32504_60022",
    x1: 110.981,
    y1: 118.328,
    x2: 110.981,
    y2: 117.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32504_60022",
    x1: 110.981,
    y1: 124.244,
    x2: 110.981,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32504_60022",
    x1: 110.981,
    y1: 123.251,
    x2: 110.981,
    y2: 122.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32504_60022",
    x1: 110.981,
    y1: 113.999,
    x2: 110.981,
    y2: 112.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32504_60022",
    x1: 110.981,
    y1: 119.002,
    x2: 110.981,
    y2: 117.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32504_60022",
    x1: 110.981,
    y1: 123.966,
    x2: 110.981,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-92.5213 27.9742) rotate(-90) scale(10.6256 1.77096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.7546 118.306) rotate(-90) scale(9.74017 4.87011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.047 26.6083) rotate(-90) scale(13.2559 1.657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32504_60022",
    x1: 116.462,
    y1: 70.4802,
    x2: 126.746,
    y2: 70.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32504_60022",
    x1: 8.1396,
    y1: 72.6637,
    x2: 8.1396,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.13993 84.3772) scale(6.71055 6.71052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_32504_60022",
    x1: 8.57649,
    y1: 92.7555,
    x2: 8.57649,
    y2: 96.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_32504_60022",
    x1: 8.1396,
    y1: 72.6637,
    x2: 8.1396,
    y2: 76.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_32504_60022",
    x1: 6.59104,
    y1: 75.761,
    x2: 6.59104,
    y2: 93.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_32504_60022",
    x1: 10.1249,
    y1: 72.6637,
    x2: 10.1249,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_32504_60022",
    x1: 121.742,
    y1: 72.6637,
    x2: 121.742,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6287C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B597D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.703 84.3772) rotate(180) scale(6.71024 6.71052)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_32504_60022",
    x1: 121.265,
    y1: 92.7555,
    x2: 121.265,
    y2: 96.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99B2BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BBD67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_32504_60022",
    x1: 121.742,
    y1: 72.6637,
    x2: 121.742,
    y2: 76.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94885C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C507A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_32504_60022",
    x1: 123.291,
    y1: 75.761,
    x2: 123.291,
    y2: 93.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_32504_60022",
    x1: 119.757,
    y1: 72.6637,
    x2: 119.757,
    y2: 96.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#739CB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#476B96"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.188 82.8821) rotate(-90) scale(20.2439 8.33574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.452 82.8821) rotate(-90) scale(20.2439 8.33574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.55831 84.9591) rotate(-90) scale(40.2798 1.64153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-25.5818 83.3847) rotate(90) scale(20.1315 0.805229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6432 84.9591) rotate(-90) scale(40.2798 1.64153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(517.64 83.3847) rotate(90) scale(20.1315 0.805297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#EADA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A49800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#696200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3C3700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1B1900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#070600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9211 156.526) scale(19.4565 19.4565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3FFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#B0FFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A9FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9CFFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#89FFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#71FFE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#53FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#30FFDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#08FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_32504_60022",
    x1: 85.8081,
    y1: 138.618,
    x2: 88.0714,
    y2: 138.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_32504_60022",
    x1: 83.5444,
    y1: 137.823,
    x2: 85.8078,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_32504_60022",
    x1: 44.0757,
    y1: 137.823,
    x2: 46.3389,
    y2: 137.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_32504_60022",
    x1: 41.812,
    y1: 138.618,
    x2: 44.0754,
    y2: 138.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_32504_60022",
    x1: 41.812,
    y1: 156.486,
    x2: 64.9216,
    y2: 156.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_32504_60022",
    x1: 44.0757,
    y1: 154.501,
    x2: 64.922,
    y2: 154.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_32504_60022",
    x1: 64.9219,
    y1: 156.486,
    x2: 88.0711,
    y2: 156.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_32504_60022",
    x1: 64.9219,
    y1: 154.501,
    x2: 85.8078,
    y2: 154.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_32504_60022",
    x1: 13.4216,
    y1: 91.7238,
    x2: 64.9219,
    y2: 91.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E76A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87B5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_32504_60022",
    x1: 64.9219,
    y1: 91.7238,
    x2: 116.462,
    y2: 91.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99C5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_32504_60022",
    x1: 64.6044,
    y1: 101.491,
    x2: 7.94216,
    y2: 135.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A94C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_32504_60022",
    x1: 64.5248,
    y1: 101.055,
    x2: 120.353,
    y2: 134.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42689C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_32504_60022",
    x1: 11.3569,
    y1: 141.715,
    x2: 64.922,
    y2: 141.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_32504_60022",
    x1: 64.9219,
    y1: 141.715,
    x2: 118.527,
    y2: 141.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.921 4.16947) scale(95.3767 95.3767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0056BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#01429F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#033082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#042571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#05226B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#062060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#091D4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A1C4A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6641 -14.692) scale(126.19 126.189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#284580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9978 15.7637) scale(127.778 127.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_32504_60022",
    x1: 11.3569,
    y1: 4.68545,
    x2: 64.922,
    y2: 4.68545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7996B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_32504_60022",
    x1: 13.4216,
    y1: 6.71056,
    x2: 64.9219,
    y2: 6.71056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#204270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#335D94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_32504_60022",
    x1: 64.9219,
    y1: 4.68545,
    x2: 118.527,
    y2: 4.68545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E76A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_32504_60022",
    x1: 64.9219,
    y1: 6.71056,
    x2: 116.462,
    y2: 6.71056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#446DA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9209 90.7311) scale(9.56944 9.56941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_32504_60022",
    x1: 64.9216,
    y1: 127.698,
    x2: 64.9216,
    y2: 107.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_32504_60022",
    x1: 18.8612,
    y1: 114.277,
    x2: 18.8612,
    y2: 113.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_32504_60022",
    x1: 18.8615,
    y1: 113.285,
    x2: 18.8615,
    y2: 112.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_32504_60022",
    x1: 18.8612,
    y1: 119.28,
    x2: 18.8612,
    y2: 118.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#283B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1D6073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#14809E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0D9AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#07AEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#03BCEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00C5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_32504_60022",
    x1: 18.8615,
    y1: 118.328,
    x2: 18.8615,
    y2: 117.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_32504_60022",
    x1: 18.8612,
    y1: 124.244,
    x2: 18.8612,
    y2: 122.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#2C3B41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#316373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#35869E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#39A2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3CB8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#3EC7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3FD0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#40D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_32504_60022",
    x1: 18.8615,
    y1: 123.251,
    x2: 18.8615,
    y2: 122.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_32504_60022",
    x1: 18.8605,
    y1: 113.999,
    x2: 18.8605,
    y2: 112.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_32504_60022",
    x1: 18.8605,
    y1: 119.002,
    x2: 18.8605,
    y2: 117.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_32504_60022",
    x1: 18.8605,
    y1: 123.966,
    x2: 18.8605,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-86.4921 44.0317) rotate(-90) scale(13.2558 2.20931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCC14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8F8F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#5C5C09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171702"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.88303 118.306) rotate(-90) scale(9.74017 4.87011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0090CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#006590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00405C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#002434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#001017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#000406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_32504_60022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9209 101.333) scale(5.6781 5.67812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#199FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1798C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#127498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0D556F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#093B4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#052530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#01090B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#000202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_32504_60022",
    x1: 87.2766,
    y1: 74.2138,
    x2: 41.931,
    y2: 28.9078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78FAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel10);
export default __webpack_public_path__ + "static/media/level10.05961eabb12dbe211d35da1d47fd7a89.svg";
export { ForwardRef as ReactComponent };